<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'bikeshop.users.close_date' | translate}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row margin-top-8">
    <div class="col-md-12 h-100">
      <span [ngClass]="{'red': startDate === '' }">*{{ 'bikeshop.users.start_date' | translate}}</span>
      <p-calendar class="max-w-full max-h-full" [(ngModel)]="startDate"></p-calendar>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-12">
      <span [ngClass]="{'red': endDate === '' }">*{{ 'bikeshop.users.end_date' | translate}}</span>
      <p-calendar [(ngModel)]="endDate" [minDate]="startDate"></p-calendar>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-12">
      <span [ngClass]="{'red': description === '' }">*{{ 'bikeshop.users.description' | translate}}</span>
      <input pInputText placeholder="e.g. Public holiday" [(ngModel)]="description"/>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-7"></div>
    <div class="col-md-5">
      <button [disabled]="busy || !isValid()" pButton class="full-width"
              label="{{ 'bikeshop.general.save' | translate}}"
              (click)="save()"></button>
    </div>
  </div>
</div>
